<template>
  <div class="chart">
    <div id="my-chart"></div>
  </div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";

HighchartsMore(Highcharts)
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
export default {
  name: "videoPie",
  components: {},
  props: {
    echartsData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    legendAlign: {
      type: String,
      default: () => {
        return 'left';
      },
    }
  },
  data() {
    return {
      myChart: {},
    };
  },
  created() {
    let _this = this;
    // window.onresize = function () {
    //   _this.myChart.reflow();
    // };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadChart();
    });
  },
  computed: {
    // 隐患类型
    hiddenDangerType() {
      return this.$store.state.select.hiddenDangerType;
    }
  },
  watch: {
    echartsData: function (newVal) {
      this.loadChart();
    },
  },
  methods: {
    loadChart() {
      let option = {
        chart: {
          type: "pie",
          backgroundColor: "rgba(0,0,0,0)",
          borderColor: "rgba(0,0,0,0)",
          options3d: {
            enabled: true,
            alpha: 58,
            beta: 0,
          },
        },
        colors: ["#009CFE", "#E7B70D", "#14B478",'#9B4ADC','#E05C5C'],
        title: {
          floating: true,
          useHTML: false,
          text: "",
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        legend: {
          enabled: true,
          align: '',
          // floating: true,
          // layout: "vertical",
          symbolRadius: 0,
          itemStyle: {
            color: "#CECECE",
            fontSize: "12px",
            fontWeight: 400,
            opacity: 1
          },
          itemHoverStyle: {'color': '#ffffff','opacity': 0.5},
          borderRadius: 6,
          itemDistance: 4,
          align: "center"
          // verticalAlign: "middle",
        },
        credits: {
          enabled: false, // 是否显示版权信息
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            innerSize: 90,
            depth: 20,
            dataLabels: {
              enabled: true,
              // inside: true,
              crop: true,
              // overflow: none,
              distance: 5,
              format: "{point.name}",
              borderColor: 'rgba(0,0,0,0)',
              style: {"color": "#CECECE","fontSize": "12px","textOutline": "0px 0px contrast"}
            },
            showInLegend: true, //重点图例显示
            borderColor: 'rgba(0,0,0,0)'
          },
        },
        series: [
          {
            type: "pie",
            name: "隐患分类",
            data: [],
          },
        ],
      };
      // console.log(this.echartsData)
      // console.log(option.series)

      option.series[0].data = this.echartsData.map((item)=>{
        // console.log(item);
        return {
          name:item.riskTypeName || item.name || "",
          y:item.totalNum || item.value || 0
        }
      })
      option.legend.align = this.legendAlign || 'left'
      
      this.myChart = Highcharts.chart("my-chart",option);
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.chart {
  // width: 100%;
  // display: flex;
  // justify-content: center;
  #my-chart {
    // width: 80%;
    height: 220px;
  }
}
</style>
